<template>
  <div class="view projects-timeline">


    <box label="New calendar">
      <full-calendar :config="calendarConfig"></full-calendar>
    </box>


    <timeline title="Old Timeline"
      :entries="timeline_row_entries" 
      :show-sidebar="show_sidebar" 
      :sidebar-width="sidebarWidth"
      @entry-click="onEntryclick"
    ></timeline>


    <template v-if="globals.show_beta_content">
      <br><br>
      <box>
      BETA: <br>
      - toggle select mellem: done bar vis procent done / time spent / projekt booked pct
      - book input on click empty input?
      - <br>
      - timeline skal gøres til et component som tager show_left_col true/false og :row_entries som er et object med rows og subrows, så kan det nemlig bruges på single project såvel som multiple projects skærm
        - timebooking  from_date  to_date daily_hrs  project_key<br>
      - timelogger: if date within timebooking create default timelog suggestion<br>
      - start screen: show timebookings today <br>
      - timeline: show actual tracked hours (weight per day) on person and project total
      - timeline show remaining daily hrs booked on person and project total
      - timeline under project, expandable show persons
      - timeline under project, expandable show workload hrs
      - filter persons/all
      </box>
    </template>

  </div>
</template>

<script>
import fdb from '.././firebase_config.js';
import mixins from '../mixins.js';
import auth from './../auth.js';
import moment from 'moment'
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Timeline from '.././components/Timeline'
import FullCalendar from '.././components/FullCalendar'
//import './../components/generated_svg_icons/linearicons/rocket'
import Inputfield from '.././components/Inputfield'
export default {
  name: 'projects_timeline',
  mixins: [ mixins.db, mixins.generic ],
  components: { 
    Box, Btn, Inputfield, 
    Timeline, 
    FullCalendar, 
  },
  data: function () {
    return {
      globals: this.$parent.globals,
      user: auth.getUser(),
      projects_currentpage: 1,
      projects_perpage: 25,
      show_view_options: false,
      show_dates: false,
      show_weeks: true,
      sidebarWidth: 120,
      show_sidebar: false,
      grid_highlight_weeks: true,
      projects_filter: undefined,
      dayInitials: ['','s','m','t','o','t','f','l','s'],
      monthTitles: ['','januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'],
      timeline: {
        field_width: 15,
        days_back: 7,
        days_ahead: 180,
      },
	  expandedRows: [],
    }
  },

  computed: {

  	calendarConfig(){
			return {
				editable: true,
				events: this.calendarEvents,				
				eventClick: this.calendarEventClicked,
				
			}
    },

    calendarEvents(){
			
      var events = []
      return events

      // below is imported from other project - needs to be adjusted in terms of content

			var bookings = this.$store.state.db.bookings
			for( var i = 0; i < bookings.length; i++ ) {
				var booking = bookings[i]
				var model = this.getModelById( booking.model_id )
				var client = this.getClientById( booking.client_id )
				if( !model ) continue
				if( !client ) continue
				events.push({
					title: 	model.name + ' ' + client.name + ' ' + booking.type.title,
					//start: 	'2019-03-01',
					start  : booking.datetime_start, //'2019-01-09T12:30:00',
					end: 	booking.datetime_end, //'2019-03-01',					
					//allDay : true,
					//cssClass: 'xxxx',
					booking: booking,					
					
				})
			}

			return events

		},	
    
    workers(){
      var output = []
      
      var list = this.$store.state.firebase.users
      if(!list) return entries

  		for( var user_key in list) {
        if(user_key == '.key') continue // why, vuexfire?
        user['.key'] = user_key
  			if( user.first_name == 'Mikkel' ) continue
        user.initials = user.email.substr(0, user.email.indexOf('@'))
  			output.push(user)
  		}
      //console.log(output)
  		return output
  	},




    timeline_row_entries(){
      var entries = []
      
      var list = this.$store.state.firebase.projects
      if(!list) return entries

      var now = moment()

      for( var project_key in list) {
        if(project_key == '.key') continue // why, vuexfire?
        
        //var project = _.cloneDeep(list[project_key])
        var project = list[project_key]

        project['.key'] = project_key

        if( project.status == 'finished' ) continue
        if( project.archived ) continue
        if( !project.start_date ) continue
        if( !project.end_date ) continue

        project.days_back = moment(project.start_date).diff(now,'days')
        project.days_ahead = moment(project.end_date).diff(now,'days')

        if( project.days_ahead < -this.timeline.days_back ) continue
        if( project.days_back > this.timeline.days_ahead ) continue

        var entry = {
          date_from: project.start_date,
          date_to: moment(project.end_date).subtract(0,'day').format('YYYY-MM-DD'),
          project: project,
          title: project.name,
          color: project.color,
          done_pct: project.done_pct,
          expanded: false,
        }        

        entries.push(entry)
      }

      entries.sort(function(a,b){
        var aed = moment(a.date_to).unix()
        var bed = moment(b.date_to).unix()
        var comp = ( aed > bed )
        if( comp ) { return 1 } else { return -1 }
      })      

      return entries
    },




    timeline_dates(){
      var output = []
      var datespan = this.timeline.days_ahead + this.timeline.days_back + 1
      for( var i = 0; i < datespan; i++ ) {
        var offset = i - this.timeline.days_back
        var momente = moment().add(offset, 'days')
        var d = parseInt(momente.format('D'))
        var m = parseInt(momente.format('MM'))
        var y = parseInt(momente.format('YY'))
        var dn = parseInt(momente.format('d')) + 1
		    var w = parseInt(momente.format('W'))
        var entry = { d:d, m:m, y:y, dn:dn, w:w }
        if( i == this.timeline.days_back ) entry.today = true
        output.push(entry)
      }
      return output
    },


    timeline_months(){
      var output = []
      for( var i = 0; i < this.timeline_dates.length; i++ ) {
        var date = this.timeline_dates[i]
        var lastOutputItem = output[output.length-1]
        if( lastOutputItem && lastOutputItem.m == date.m ) {
          output[output.length-1].days_count++
        } else {
          output.push({
            m: date.m,
            days_count: 1,
          })
        }
      }
      return output
    },

	timeline_weeks(){
      var output = []
      for( var i = 0; i < this.timeline_dates.length; i++ ) {
        var date = this.timeline_dates[i]
        var lastOutputItem = output[output.length-1]
        if( lastOutputItem && lastOutputItem.w == date.w ) {
          output[output.length-1].days_count++
        } else {
          output.push({
            w: date.w,
            days_count: 1,
          })
        }
      }
      return output
    },
    
    timeline_content_container_css(){
      var css = {}
      css.width = 'calc(100% - ' + this.sidebarWidth + 'px)'
      if( !this.show_sidebar ) css.width = '100%'
      return css
    },

    timeline_content_css(){
      return {
        width: (this.timeline.days_ahead + 1 + this.timeline.days_back) * this.timeline.field_width + 'px',
      }
    },

    timeline_field_style_css(){
      return {
        width: this.timeline.field_width + 'px',
      }
    },

  },
  methods: {

	isRowExpanded(row_i){
		console.log
		if( this.expandedRows[row_i] && this.expandedRows[row_i] == true ) return true
		return false
	},

	toggleRowExpanded(row_i,boolean){
		if( boolean === undefined ) boolean = !this.isRowExpanded(row_i)
		this.$set( this.expandedRows, row_i, boolean )
	},

    timeline_get_month_days_count(m){
      var count = 0
      for( var i = 0; i < this.timeline_dates.length; i++ ) if( this.timeline_dates[i].m == m ) count++
      return count
    },

    timeline_month_field_css(m) {
      return {
        width: this.timeline.field_width * m.days_count + 'px',
      }
    },

	timeline_week_field_css(m) {
      return {
        width: this.timeline.field_width * w.days_count + 'px',
      }
    },


    timeline_field_classes(d){
      var classes = {}
      if( d.today ) classes.today = true
      classes[ 'day' + parseInt(d.dn) ] = true
      return classes
    },

//------------------------------------------------------------------------------

	timeline_entry_marker_css(data) {
      var bgColor = data.color
      var textColor = this.idealTextColor(bgColor)
      return {
        left: data.l * this.timeline.field_width + 'px',
        width: data.w * this.timeline.field_width + 'px',
        'background-color': bgColor,
        'color': textColor,        
      }
  },

  timeline_entry_marker_classes(entry){
    var c = {}
    c.l = true
    return c
  },

	timeline_entry_marker_end(side,data){
		return {}
		var bgColor = data.color
		var css = {
          'border-color': bgColor+' transparent transparent transparent',
        }
		if( side == 'l' ) {
			css['border-width'] = '10px 10px 0 0'
			css['border-color'] = bgColor+' transparent transparent transparent'
		}
		if( side == 'r' ) {
			css['border-width'] = '0 10px 10px 0'
			css['border-color'] = 'transparent '+bgColor+' transparent transparent'
		}
		return css
	},

	onEntryclick(entry){
    globals.modal_timeline_project_popup.project = entry.project
		globals.modal_timeline_project_popup.active = true
	},

	timeline_entry_marker_title(data){
    return {}
		var bgColor = data.color
		return {
			'background-color': bgColor
		}
	},

	timeline_entry_marker_done_pct(data){
		var done_pct = data.done_pct
		return { 'width': done_pct+'%' }
	},

//------------------------------------------------------------------------------

    timeline_entry_marker_project(project,timeline) {
      //console.log(project)
      var output = {}
      var todayIndex = this.timeline.days_back

      var start_days_diff = moment(project.start_date).diff(moment(), 'days')
      var end_days_diff = moment(project.end_date).diff(moment(), 'days') + 1

      start_days_diff += todayIndex
      end_days_diff += todayIndex

      //if( start_days_diff < timeline.days_back ) start_days_diff += timeline.days_back

      //timeline.days_back
      //timeline.days_ahead

      var maxwidth = ( this.timeline.days_ahead + 1 + this.timeline.days_back ) - start_days_diff

      output.w = 0
      output.l = start_days_diff
      if( output.l < 0 ) {
        output.w = output.l
        output.l = 0
      }
      output.w += end_days_diff - start_days_diff
      if( output.w > maxwidth ) output.w = maxwidth

      output.color = project.color
      if( !output.color && project.client_key ) output.color = this.$store.state.firebase.clients[ project.client_key ].color
      if( !output.color ) output.color = '#333'

	  output.done_pct = this.getProjectDonePct(project)

      return output
    },

//------------------------------------------------------------------------------

	show_worker_booking_indicator(date,date_i,project){
		if( date.today ) return false
		if( date_i < this.timeline.days_back ) return false
		if( date_i - this.timeline.days_back > project.days_ahead ) return false
		if( date_i - this.timeline.days_back < project.days_back ) return false
		return true
	},

//------------------------------------------------------------------------------

	get_date_worker_timebooking(d,i,project,user){
		var date = '20'+d.y+'-'+this.strpad(d.m,2)+'-'+this.strpad(d.d,2)
		for( var i = 0; i < this.timebookings.length; i++ ) {
			var timebooking = this.timebookings[i]
			if( timebooking.project_key != project['.key'] ) continue
			if( timebooking.user_key != user['.key'] ) continue
			if( timebooking.date != date ) continue
			return timebooking
		}
	},

	get_date_worker_timebooking_value(d,i,project,user){
		var existing_timebooking = this.get_date_worker_timebooking(d,i,project,user)
		if( !existing_timebooking ) return 0
		return existing_timebooking.hours
	},

//------------------------------------------------------------------------------

	update_worker_booking(e,d,i,project_i,project,user,user_i) {
		var ref = 'jh2g3'+project_i+user_i+i
		var val = this.$refs[ref][0].value
		val = parseFloat(val)
		if( val < 0 ) val = 0
		if( val > 24 ) val = 24

		var existing_booking = this.get_date_worker_timebooking(d,i,project,user)
		if( existing_booking ) {
			if( val == 0 ) {
				// delete it
			}
			if( val > 0 ) {
				// update it
			}
			var update = {
				hours: val,
				modified: moment().format('YYYY-MM-DD hh:mm:SS'),
			}
			fdb.ref('timebookings').child( existing_booking['.key'] ).update(update)
	        eventBus.$emit('toast', {text:'Booking updated: '+val+' hours booked'})

		}
		if( !existing_booking ) {
			if( val == 0 ) return
			var entry = {
				project_key: project['.key'],
				user_key: user['.key'],
				hours: val,
				date: '20'+d.y+'-'+this.strpad(d.m,2)+'-'+this.strpad(d.d,2),
				created: moment().format('YYYY-MM-DD hh:mm:SS'),
			}
			fdb.ref('timebookings').push(entry)
			eventBus.$emit('toast', {text: val+' hours booked'})
		}

	},

//------------------------------------------------------------------------------

	strpad(n, width, z){
		z = z || '0';
	    n = n + '';
	    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	},

//------------------------------------------------------------------------------

    getProjectDonePct: helpers.getProjectDonePct,
    getProjectHoursEstimate: helpers.getProjectHoursEstimate,
    getProjectBudgetTotal: helpers.getProjectBudgetTotal,
    outputMoney: helpers.outputMoney,

    colorNameGetHex: helpers.colorNameGetHex,
    idealTextColor: helpers.idealTextColor,
    getRGBComponents: helpers.getRGBComponents,


    gotoProject(project){
      this.$router.push('project/'+project['.key'])
    },


    gotoClient(project){
      this.$router.push('client/'+project.client_key)
    },


    getprojectStatus(project){
      if( !project.status ) return
      if( !this.globals.projectStatuses ) return
      if( !this.globals.projectStatuses[project.status] ) return
      if( !this.globals.projectStatuses[project.status].title ) return
      return this.globals.projectStatuses[project.status].title
    },


    getProjectClient(project){
      var client = { name:undefined }
      //if( project.client_key )
      if( project.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[ project.client_key ] ) client = this.$store.state.firebase.clients[ project.client_key ]
      return client
    },

    getFilteredItems( items, filterString ){

      if( !filterString || filterString == undefined || filterString == '' ) return items

      filterString = filterString.toLowerCase()

      //if( typeof items === 'object' ) items = Object.keys(items).map((k) => items[k])

      items = items.filter(function(item){
        //console.log(item)
        var bool = false
        for( var k in item ){
          var v = item[k]

          if(v.archived) return false
          // if attrs_array defined, and if !in_array attrs_array continue
          //console.log(k)
          //console.log(v)
          if( v.toLowerCase().indexOf(filterString) >= 0 ) bool = true
        }
        return bool
      })
      return items
    },

    projects_filter_updated(){
      this.projects_currentpage = 1
    },

    getPaginatedItems(items){

      //if( typeof items === 'object' ) items = Object.keys(items).map((k) => items[k])

      var start = this.projects_perpage * (this.projects_currentpage - 1)
      var end = this.projects_perpage * this.projects_currentpage

      items = items.slice(start,end)

      // this.projects_currentpage
      // this.projects_perpage

      //console.log(items)


      return items
    },



    calendarEventClicked(info){
			//alert('Event: ' + info.event.title)
			//alert('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY)
      //alert('View: ' + info.view.type)
      
      alert(123)
      return

			var booking_id = info.event.extendedProps.booking.id

			// change the border color just for fun
			//info.el.style.borderColor = 'red'
      this.goto('/booking/'+booking_id)
      
		},

    
    

  },//methods



}
</script>



// WEBPACK FOOTER //
// Projects_timeline.vue?dbee93e6